import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

function Loading() {
  return <div className="py-24 text-center text-sm text-ink-400">加载中…</div>;
}

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  // 等认证状态加载完再判断，避免硬刷新时把已登录用户弹回登录页
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return <>{children}</>;
}

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
